import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class DevExpressReportSettings<T extends EMode = EMode.entity> {
  /** Alias: logo1Url */
  logo1Url?: string;
  /** Alias: logo2Url */
  logo2Url?: string;
  /** Alias: addressLineOverride */
  addressLineOverride?: string;
  /** Alias: footerHtml */
  footerHtml?: string;
  /** Alias: logo1PosX */
  logo1PosX?: number;
  /** Alias: logo1PosY */
  logo1PosY?: number;
  /** Alias: logo2PosX */
  logo2PosX?: number;
  /** Alias: logo2PosY */
  logo2PosY?: number;

  __typename?: string;
}

const fields: FieldDefinitions<DevExpressReportSettings> = {
  logo1Url: {
    alias: 'logo1Url',
  },
  logo2Url: {
    alias: 'logo2Url',
  },
  addressLineOverride: {
    alias: 'addressLineOverride',
  },
  footerHtml: {
    alias: 'footerHtml',
  },
  logo1PosX: {
    alias: 'logo1PosX',
  },
  logo1PosY: {
    alias: 'logo1PosY',
  },
  logo2PosX: {
    alias: 'logo2PosX',
  },
  logo2PosY: {
    alias: 'logo2PosY',
  },
  __typename: {
    alias: '__typename',
  },
};

export const devExpressReportSettingsEntityDefinition: EntitiyDefinition<DevExpressReportSettings> =
  {
    local: {},
    remote: {
      queryName: 'getDevExpressReportSettings',
      fragmentName: 'DevExpressReportSettings',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'upsertReportSettings',
          args: [{ name: 'settings', type: 'UpsertDevExpressReportSettings' }],
        },
      },
    },
    fieldDefinitions: fields,
  };
